import window from 'global/window';
import type {PaletteMode} from '@mui/material';
import {getStylePropertyDemo} from './getStylePropertyDemo';

export const getStylePropertyFn = (
	mode: PaletteMode,
	opts?: {demo?: boolean},
) => {
	const {demo} = opts || {};

	return !demo && window.Netx?.getStyleProperty
		? window.Netx.getStyleProperty
		: (key: string) => getStylePropertyDemo(key, mode);
};
